import React, { Component } from "react";
import { Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import { IntlProvider } from "react-intl";
import IntlGlobalProvider from "../lngProvider/IntlGlobalProvider";
import AppLocale from "../lngProvider";
import asyncComponent from "../utils/asyncComponent";
import Header from "../components/Header";
import Breadcrumb from "../components/Breadcrumb";
import Footer from "../components/Footer";
import FooterMobileNav from "../components/FooterMobileNav";
import "moment/locale/th";
import "../assets/style";
import NotiModal from "./routes/NotiModal";
import { authProfileFetch,memberProfileFetch, privilegesFetch } from "../actions";
import PopupAuth from "../components/popup/auth/PopupAuth";

import PopupCommingSoon from "../components/popup/PopupCommingSoon";
import PopupConsent from "../components/popup/PopupConsent";
import PopupPDPA from "../components/popup/PopupPDPA";
import PopupTermCondition from "../components/popup/PopupTermCondition";
import PopupTier from "../components/popup/PopupTier";
import PopupRedeemStep from "../components/popup/PopupRedeemStep";
// import PopupChangeDefaultPassword from "../components/popup/forgotPassword/PopupChangeDefaultPassword";

import { signinOpenConsent , signOpenChangeDefaultPassword } from "../actions";
import CookieConsent, { Cookies } from "react-cookie-consent";

import $ from "jquery";
window.jQuery = window.$ = $;

const RGB_HEX = /^#?(?:([\da-f]{3})[\da-f]?|([\da-f]{6})(?:[\da-f]{2})?)$/i;

const hex2RGB = (str, a) => {
  const [ , short, long ] = String(str).match(RGB_HEX) || [];

  if (long) {
    const value = Number.parseInt(long, 16);
    return 'rgb(' + String(value >> 16) + ', ' + String(value >> 8 & 0xFF) + ', ' + String( value & 0xFF)+ ', ' + a +  ')';
  
  } 
};

class App extends Component {

  state ={
    auth:true,
    displayPDPA: false,
  }
  
  componentWillMount() {
    if (this.props.initURL === "") {
      this.props.setInitUrl(this.props.history.location.pathname);
    }
    if (this.props.authMember && this.props.authMember.success === true) {
      this.props.authProfileFetch();
    }
  }

  // componentWillReceiveProps(nextProps){
  //   if(nextProps.authMember && nextProps.authMember.color && nextProps.authMember.color.primary_color && nextProps.authMember.color.secondary_color && nextProps.authMember.color.gradient){
  //     let colorDefault = nextProps.authMember.color.primary_color;
  //     let colorSecondary = nextProps.authMember.color.secondary_color;
  //     document.body.style.setProperty('--default', colorDefault);
  //     document.body.style.setProperty('--g1',  hex2RGB(colorDefault , 0.5) );
  //     document.body.style.setProperty('--g2',  hex2RGB(colorDefault , 0.5) );
  //     document.body.style.setProperty('--secondary', colorSecondary);
  //     document.body.style.setProperty('--gradient', nextProps.authMember.color.gradient);
  //   }
  // }

  async componentDidMount(){
    let colorDefault = '#ED1B2E';
    let colorSecondary = '#FB8894';
    let gradient = "linear-gradient(270deg, #ED1B2E 14.9%, #5F5757 56.37%, #BFBFBF 79.25%)";
  
 
    // if(this.props.authMember && this.props.authMember.color && this.props.authMember.color.primary_color && this.props.authMember.color.secondary_color){
    //   colorDefault = this.props.authMember.color.primary_color;
    //   colorSecondary = this.props.authMember.color.secondary_color;
    //   gradient = this.props.authMember.color.gradient;
    // } 
   
    document.body.style.setProperty('--default', colorDefault);
    document.body.style.setProperty('--g1',  hex2RGB(colorDefault , 0.5) );
    document.body.style.setProperty('--g2',  hex2RGB(colorDefault , 0.5) );
    document.body.style.setProperty('--secondary', colorSecondary);
    document.body.style.setProperty('--gradient', gradient);
      
      
  }

  
  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
  
    console.error(error, errorInfo)
  }


  render() {
    const { match, locale, authMember, pdpa_reqest } = this.props;
    const currentAppLocale = AppLocale[locale.locale];
    // console.log("By C : Consent",this.props.is_consent);
    // console.log("By C : Change Password ",this.props.is_default_password_changed);

    // console.log(this.props.authMember , this.props.displayConsent , this.props.is_consent )
    if (this.props.authMember && this.props.authMember.success && !this.props.is_consent ) {
      this.props.signinOpenConsent(this.props.authMember)
    }

    // if (this.props.authMember && this.props.authMember.success && this.props.is_consent && !this.props.is_default_password_changed ) {
    //   this.props.signOpenChangeDefaultPassword()
    // }

    
    return (
      <IntlProvider
        locale={currentAppLocale.locale}
        messages={currentAppLocale.messages}
      >
        <IntlGlobalProvider>
          <div className="wrapper">
            <Header />
            <Breadcrumb path={this.props.location.pathname} />
            
            {
                (authMember && authMember.success) ? (
        <Switch>

            <Route
                exact
                path={`${match.url}`}
                component={asyncComponent(() =>
                  import("./routes/privilege/list")
                )}
                // component={asyncComponent(() => import("./routes/home"))}
              />
                   
            <Route
                exact
                path={`${match.url}privilege`}
                component={asyncComponent(() =>
                  import("./routes/privilege/list")
                )}
              />
              <Route
                exact
                path={`${match.url}privilege/detail/:id`}
                component={asyncComponent(() =>
                  import("./routes/privilege/detail")
                )}
              />
              <Route
                exact
                path={`${match.url}privilege/category/:id`}
                component={asyncComponent(() =>
                  import("./routes/privilege/list")
                )}
              />

              <Route
                exact
                path={`${match.url}faq`}
                component={asyncComponent(() => import("./routes/faq"))}
              />
          
              <Route
                exact
                path={`${match.url}term`}
                component={asyncComponent(() => import("./routes/term"))}
              />

        <Route
                exact
                path={`${match.url}privacy-policy`}
                component={asyncComponent(() => import("./routes/term"))}
              />

              <Route
                exact
                path={`${match.url}contact`}
                component={asyncComponent(() => import("./routes/contact"))}
              />
             
                <Route
                  exact
                  path={`${match.url}my-profile`}
                  component={asyncComponent(() =>
                    import("./routes/my/profile")
                  )}
                />
              
              
        <Route exact path={`${match.url}request-reset-password`} component={asyncComponent(() => import("./routes/request-reset-password"))} />
			  <Route exact path={`${match.url}reset-password/:token`} component={asyncComponent(() => import("./routes/reset-password.js"))} />


                <Route
                  exact
                  path={`${match.url}history/point-expire`}
                  component={asyncComponent(() =>
                    import("./routes/history/point-expire")
                  )}
                />
           
                <Route
                  exact
                  path={`${match.url}history/point-transfer`}
                  component={asyncComponent(() =>
                    import("./routes/history/point-transfer")
                  )}
                />
          
              
                <Route
                  exact
                  path={`${match.url}my-wishlist`}
                  component={asyncComponent(() =>
                    import("./routes/my/wishlist")
                  )}
                />
             
             
                <Route
                  exact
                  path={`${match.url}my-coupon`}
                  component={asyncComponent(() => import("./routes/my/coupon"))}
                />
            
             
                <Route
                  exact
                  path={`${match.url}my-coupon/:id`}
                  component={asyncComponent(() =>
                    import("./routes/history/detail")
                  )}
                />

              <Route
                exact
                path={`${match.url}term_condition`}
                component={asyncComponent(() => import("./routes/term_con"))}
              />

              <Route
                exact
                path={`${match.url}privacy-policy`}
                component={asyncComponent(() => import("./routes/term"))}
              />
              
              <Route
                exact
                path={`${match.url}search`}
                component={asyncComponent(() => import("./routes/search"))}
              />

            <Route
                component={asyncComponent(() =>
                  import("../components/error/Error404")
                )}
              />
                </Switch>) 
                
                : (<Switch>

                  <Route
                exact
                path={`${match.url}`}
                component={asyncComponent(() => import("./routes/authen"))}
              />

        
              <Route
                exact
                path={`${match.url}faq`}
                component={asyncComponent(() => import("./routes/faq"))}
              />


              <Route exact path={`${match.url}request-reset-password`} component={asyncComponent(() => import("./routes/request-reset-password"))} />
              <Route exact path={`${match.url}reset-password/:token`} component={asyncComponent(() => import("./routes/reset-password.js"))} />


              <Route
                exact
                path={`${match.url}privacy-policy`}
                component={asyncComponent(() => import("./routes/term"))}
              />



             {/* <Route
                exact
                path={`${match.url}term`}
                component={asyncComponent(() => import("./routes/term"))}
              /> */}

               <Route
                exact
                path={`${match.url}term_condition`}
                component={asyncComponent(() => import("./routes/term_con"))}
              />

              <Route
                exact
                path={`${match.url}contact`}
                component={asyncComponent(() => import("./routes/contact"))}
              />

              <Route
               
                component={asyncComponent(() => import("./routes/authen"))}
              />

              {/* <Route
                exact
                path={`${match.url}signup`}
                component={asyncComponent(() => import("./routes/authen"))}
              /> */}

        

                </Switch>)
              }
            
            
            <div
              style={{ display: "block", position: "relative", clear: "both" }}
            ></div>
          </div>
          <Footer />
          <FooterMobileNav />
          {/* <CookieConsent
            location="bottom"
            buttonText="Accept & Close"
            cookieName="CookieConsent"
            style={{ background: "#000",alignItems: "center",padding:"5px"}}
            buttonStyle={{  background: "var(--default)",color: "#FFF", fontSize: "14px",borderRadius: "5px",padding:"10px 20px"}}
            expires={14}
          >We use cookies on this website. Cookies are small text files, 
          stored on your computer. We use cookies to provide statistics that 
          help us give you the best experience of our site. <br/> 
          By continuing to use the site without changing settings, you are agreeing to our use of cookies.{" "}
          <span style={{fontSize:"14px",color:"#fff !important"}} onClick={()=>window.location.href = '/privacy-policy'}><u>Read Privacy Policy</u></span>
          </CookieConsent> */}


        </IntlGlobalProvider>
        <NotiModal />
        {/* {<PopupAuth />}
        <PopupPDPA display={this.state.displayPDPA} closeModal={() => this.setState({
          displayPDPA: false
        })}/>
        <PopupRedeemStep display={pdpa_reqest}/>
        {authMember && authMember.success?"":<PopupConsent />}
        <PopupConsent />
        
        <PopupTermCondition setDisplay={() => {
          this.setState({
            displayPDPA: true
          })
        }}/> */}

        {/* <PopupCommingSoon/> */}
        {/* <PopupChangeDefaultPassword /> */}
        <PopupTier />
      </IntlProvider>
    );
  }
}

const mapStateToProps = ({ setting: { locale }, auth: { authMember , displayConsent , authData, pdpa_reqest } }) => {
  const is_default_password_changed = authMember && authMember.is_change_password_default === "true" ? true : false
  const is_consent = authMember  && authMember.consent_status  === "enable" ? true : false
  return { locale, authMember , is_default_password_changed ,is_consent , displayConsent, pdpa_reqest};
};

export default connect(mapStateToProps, {
  authProfileFetch,
  memberProfileFetch,
  signinOpenConsent,
  signOpenChangeDefaultPassword,
  privilegesFetch
})(App);